<template>
  <v-dialog
    v-model="getChangePasswordModal"
    width="800"
    content-class="add-head-modal"
  >
    <v-card class="py-16 px-8 rounded-sm elevation-0 white">
      <v-row>
        <v-col offset-md="3" md="6">
          <p class="mb-8 font-20px dark-color--text text-center">
            {{ $t("Reset.change_password") }}
          </p>
          <div>
            <label class="mb-4 label sub--text">{{ $t("Reset.old_password") }}</label>
            <v-text-field
              solo
              outlined
              flat
              class="focus-input"
              height="44px"
              :append-icon="show1 ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
              @click:append="show1 = !show1"
              :type="show1 ? 'text' : 'password'"
              :rules="[rules2.required]"
              v-model="forms.old_password"
            ></v-text-field>
          </div>
          <div class="mt-0">
            <label class="mb-4 label sub--text">{{ $t("Reset.new_password") }}</label>
            <v-text-field
              solo
              outlined
              flat
              class="focus-input"
              height="44px"
              :append-icon="show2 ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
              @click:append="show2 = !show2"
              :type="show2 ? 'text' : 'password'"
              :rules="[rules.required, rules.min]"
              hint="Минимум 8 букв "
              v-model="forms.new_password"
            ></v-text-field>
          </div>
          <div class="mt-10">
            <v-btn
              width="100%"
              height="44px"
              elevation="0"
              hide-selected="true"
              class="button"
              color="main_color white--text"
              @click="changePassword"
            >
              {{ $t("Default.save") }}
            </v-btn>
            <v-btn
              width="100%"
              height="44px"
              elevation="0"
              hide-selected="true"
              class="button mt-2"
              color="sub white--text"
              @click="getChangePasswordModal = false"
            >
              {{ $t("Default.cancel") }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>
<script>
import { computed, ref, watch } from "@vue/composition-api";
import { shortComputed } from "@/utility/helpers";
import { useStore } from "vuex-composition-helpers";
import { globalVariables } from "@/utility/variables";
import { GlobalMutationTypes } from "@/store/modules/global/types";
import { DispatchTypes } from "@/store/modules/auth/types";

export default {
  name: "getChangePasswordModal",
  setup(props, { root }) {
    const store = useStore();
    const { userInfo } = globalVariables();
    const show1 = ref(false);
    const show2 = ref(false);
    const getChangePasswordModal = shortComputed(
      {
        storeType: "global",
        key: "getChangePasswordModal",
      },
      GlobalMutationTypes.setChangePasswordModal
    );

    const currentAssistant = computed(
      () => store.state.assistant.assistantById
    );

    const forms = ref({
      old_password: "",
      new_password: "",
      user_id: currentAssistant.value.id,
    });

    const rules = ref({
      required: (value) => !!value || "Обязательное поле.",
      min: (v) => v.length >= 8 || "Минимум 8 букв",
    });

    const rules2 = ref({
      required: (value) => !!value || "Обязательное поле.",
    });

    const changePassword = () => {
      store.dispatch(DispatchTypes.changePass, forms.value).then(() => {
        store.commit(GlobalMutationTypes.setChangePasswordModal, false);
      });
    };

    return {
      store,
      getChangePasswordModal,
      userInfo,
      changePassword,
      show1,
      show2,
      forms,
      rules,
      rules2,
      currentAssistant,
    };
  },
};
</script>
